import { ROUTE_FAN_BOX_MESSAGE_ROOT, ROUTE_FAN_BOX_MESSAGE_NEW, ROUTE_FAN_BOX_MESSAGE_EDIT } from './constants';
import FanBomMessageRoot from './FanBomMessageRoot';
import FanBoxNew from './FanBoxMessageNew';
import FanBoxMessageEdit from './FanBoxMessageEdit';
import FanBomMessageList from './FanBoxList';

export default {
  path: ROUTE_FAN_BOX_MESSAGE_ROOT,
  component: FanBomMessageRoot,
  indexRoute: {
    component: FanBomMessageList
  },
  childRoutes: [
    {
      path: ROUTE_FAN_BOX_MESSAGE_NEW,
      component: FanBoxNew
    },
    {
      path: ROUTE_FAN_BOX_MESSAGE_EDIT,
      component: FanBoxMessageEdit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/FanBox/router.js